module.exports = __webpack_public_path__ + "static/media/ortho-icon@2x.86d833d3.png";